const CURRENT_YEAR = new Date().getFullYear();

function clampStr(value, min, max, component = 'DD') {
  if (value.length === 0) {
    return value;
  }

  const clampedValue = Math.max(min, Math.min(Number(value), max));

  if (component === 'DD' || component === 'MM') {
    return clampedValue.toString().padStart(2, '0');
  }

  return clampedValue.toString();
}

export const monthClamper = (value) => clampStr(value, 1, 12, 'MM');
export const yearClamper = (value) => clampStr(value, 1, CURRENT_YEAR, 'YYYY');

export function getInputDateClampers(date) {
  return {
    MM: monthClamper,
    DD: (value) => {
      if (value.length === 0) {
        return value;
      }

      const month = date.MM || '1';
      const year = date.YYYY || CURRENT_YEAR.toString();
      const maxDays = new Date(+year, +month, 0).getDate();

      return clampStr(value, 1, maxDays, 'DD');
    },
    YYYY: yearClamper
  };
}
